import React from "react";
import Modal from "@mui/joy/Modal";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import Sheet from "@mui/joy/Sheet";
import ProjectModalContent from "./ProjectModalContent";
import ProjectModalDetails from "./ProjectModalDetails";
import { IoClose } from "react-icons/io5";

export default function ProjectModal({ open, handleClose, project }) {
  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-desc"
      open={open}
      onClose={handleClose}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Sheet
        variant="outlined"
        sx={{
          width: "90%",
          height: "80%",
          padding: "24px",
          borderRadius: "48px",
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row" },
          overflowY: { xs: "scroll", sm: "scroll", md: "visible" },
          gap: "8px",
        }}
      >
        <IconButton
          size="medium"
          sx={{
            position: "absolute",
            top: "28px",
            right: "28px",
            zIndex: 1,
            background: "rgba(255, 255, 255, 0.7)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.5)",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          }}
          onClick={handleClose}
        >
          <IoClose />
        </IconButton>
        <ProjectModalContent project={project} />
        <Divider
          orientation="horizontal"
          variant="middle"
          flexItem
          sx={{
            display: { xs: "block", sm: "block", md: "none" },
            width: "80%",
            alignSelf: "center",
          }}
        />
        <ProjectModalDetails project={project} />
      </Sheet>
    </Modal>
  );
}
